import React from 'react'
import {StyleSheet, View} from 'react-native'
import {Trans} from '@lingui/react/macro'

import {atoms as a, useTheme} from '#/alf'
import {FormError} from '#/components/forms/FormError'
import {Text} from '#/components/Typography'
import {FormContainer} from './FormContainer'

export function MethodSelection({
  error,
  onSelectMethod,
  onPressBack,
}: {
  error: string
  onSelectMethod: (method: 'wid' | 'email') => void
  onPressBack: () => void
}) {
  const t = useTheme()

  return (
    <FormContainer
      testID="loginForm"
      titleText={<Trans>Sign in</Trans>}
      style={{backgroundColor: 'transparent'}}>
      <View>
        <Text
          style={[
            a.text_sm,
            a.font_medium,
            t.atoms.text_contrast_medium,
            a.mb_sm,
            styles.labelText,
          ]}>
          <Trans>Remove user</Trans>
        </Text>
        <View
          style={[
            a.gap_md,
            a.align_center,
            a.mt_md,
            {maxWidth: 300, width: '100%', alignSelf: 'center'},
          ]}>
          <Text
            style={[
              a.text_sm,
              t.atoms.text_contrast_medium,
              {textAlign: 'center'},
            ]}>
            <Trans>Choose how you want to confirm account deletion:</Trans>
          </Text>
          <button
            className={'BackButton'}
            onClick={() => onSelectMethod('wid')}>
            <Trans>Use WID (QR code)</Trans>
          </button>
          <button
            className={'BackButton'}
            onClick={() => onSelectMethod('email')}>
            <Trans>Use email confirmation</Trans>
          </button>
        </View>
      </View>
      <FormError error={error} />
      <View style={[a.flex_row, a.align_center, a.pt_md, a.self_center]}>
        <button className={'BackButton'} onClick={onPressBack}>
          <Trans>Back</Trans>
        </button>
        <View style={a.flex_1} />
      </View>
    </FormContainer>
  )
}

const styles = StyleSheet.create({
  labelText: {
    textAlign: 'center',
    fontSize: 16,
  },
})
